module.exports = __webpack_public_path__ + "static/media/toggle_compact_Selected.473e1551.svg";